@if (params.value) {
  <span class="ins-avalibilty">متاح</span>
} @else {
  <span class="ins-non-avalibilty">غير متاح</span>
}
